import matchEntities from '../src/shared/entityHelpers';
import { getLaadPaalDocumentTitle } from './netherlands/seo';

function setPageTitle(to) {
  const { name } = to;
  if (matchEntities(['NETHERLANDS']) && name === 'OpenMarketCities') {
    document.title = getLaadPaalDocumentTitle(to.params.name);
    return;
  }
  document.title = name ? `Qwello | ${name}` : 'Qwello';
}
export default setPageTitle;
